export const CONFIG = {
  order: {
    ordersPerPage: 30,
    // -- One day of orders in the by-date drill-down. High enough that a busy
    // -- day fits in the modal without paging; the modal says so if it does not.
    ordersPerDayDrilldown: 200,
  },
};
